<template>
  <div class="bj-form">
    <el-form
      ref="form"
      v-bind="$attrs"
      :model="source" 
      class="bj-form"
    >
      <el-row :gutter="48">
        <el-col
          v-for="item in config"
          :key="item.key"
          :span="item.hidden ? 0 : item.span || 8"
        >
          <el-form-item
            v-if="!item.hidden"
            :label="item.label"
            :prop="item.key"
            :label-width="item.labelWidth || labelWidth || '120px'"
            v-bind="item.itemProps"
          >
            <slot
              v-if="item.component === 'slot'"
              :name="item.slotName"
              :props="item"
            />
            <div
              v-else-if="item.component === 'innerText'"
              :class="item.innerClass"
              :style="item.style"
            >
              {{ item.innerText || source[item.key] }}
            </div>
            <template v-else>
              <div
                class="bj-flex-align-center"
              >
                <component
                  :is="item.component"
                  v-model="source[item.key]"
                  :class="componentStyle(item.component)"
                  v-bind="item.props"
                  v-on="item.listeners"
                  size="small"
                >
                  <template v-if="item.component === 'el-radio-group'">
                    <el-radio-button
                      v-for="(radio, radioIndex) in item.data"
                      :key="radioIndex"
                      :label="radio.value"
                    >
                      {{ radio.label }}
                    </el-radio-button>
                  </template>

                  <template v-if="item.component === 'el-checkbox-group'">
                    <el-checkbox-button
                      v-for="(checkbox, checkboxIndex) in item.data"
                      :key="checkboxIndex"
                      :label="checkbox.value"
                    >
                      {{ checkbox.label }}
                    </el-checkbox-button>
                  </template>

                  <template v-if="item.component === 'el-select'">
                    <el-option
                      v-for="(option, optionIndex) in item.data"
                      :key="optionIndex"
                      :label="option.label"
                      :value="option.value"
                    />
                  </template>
                </component>
                <div
                  v-if="item.after"
                  class="bj-form__after"
                >
                  {{ item.after }}
                </div>
              </div>
              <div
                v-if="item.tips"
                class="bj-form__tips"
                v-html="item.tips"
              />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'BjForm',
  components: {},
  props: {
    config: {
      type: Array,
      default: () => []
    },
    source: {
      type: Object,
      default: () => ({})
    },
    labelWidth: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    resetFields() {
      this.$refs.form.resetFields();
    },
    componentStyle(component) {
      const notFullList = ['el-switch'];
      return notFullList.find(v => v === component) ? '' : 'form-item__full';
    },
    async validate() {
      const valid = await this.$refs.form.validate();
      return valid;
    }
  }
};
</script>
<style lang="less">
  .el-form-item{
    margin-bottom: 16px;
  }
  .el-form-item__label{
    color: rgba(0, 0, 0, 0.85);
  }
</style>
<style lang="less" scoped>
.bj-form{
  .el-row{
    display: flex;
    flex-wrap: wrap;
  }
}
.form-item__full{
  width: 100% !important;
  flex: 1 !important;
}
</style>